import { render } from "./ConfirmedPage.vue?vue&type=template&id=212c8558&scoped=true"
import script from "./ConfirmedPage.vue?vue&type=script&lang=js"
export * from "./ConfirmedPage.vue?vue&type=script&lang=js"

import "./ConfirmedPage.vue?vue&type=style&index=0&id=212c8558&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212c8558"]])

export default __exports__